import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useAdminContext } from "../adminstore/Admin-Context";
import EditWarning from "../header/EditWarning";
import { useNavigate, useLocation } from 'react-router-dom';
import { handleAnalyticsAction } from "../../views/landingpages/LTDReport";
import UIConstant from "../../apiclients/UIConstant";
import { show_links_tab } from "../../apiclients/apiurls";
import ChatBotView from "../../ai-chat-buddy/features/chatbot/components/ChatBitView";
import { Tooltip } from "react-tooltip";
import { isFiveNineAccount } from "../../views/Login";

function MainLinks(props) {
  const [isActive, setActive] = useState("false");
  const { isEdited, setEdited, setOpenedWindow } = useAdminContext(); // Access isEdited from context
  const [showWarning, setShowWarning] = useState(false);
  const [targetView, setTargetView] = useState('');
  const warningToggle = () => setShowWarning(!showWarning)
  const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
  const isBillingGroup = isAdminSession?.permissions
    ? (isAdminSession?.permissions.includes(UIConstant.ALLOW_ACCESS_BILLING))
    : true;

  const navigate = useNavigate();
  const location = useLocation();
  const ToggleClass = () => {
    setActive(!isActive);
  };
  const isFiveNineAcc = isFiveNineAccount();

  const handleOk = () => {
    setEdited(false);
    if (targetView === "analyticslanding") {
      const windowsMap = {};
      openLTDReport(windowsMap, navigate);
      // window.location.reload();
    } else {
      window.location.href = targetView;
    }
    setShowWarning(false);
  };

  function goToSublink(e, tview, tabid) {
    if (isEdited) {
      setTargetView(tview);
      setShowWarning(true);
      return;

    }
    if (tview === "analyticslanding") {

      const windowsMap = {};
      openLTDReport(windowsMap, navigate)
    } else {
      sessionStorage.setItem("mainTabId", tabid);
      window.location.href = tview;
    }
  }

  async function openLTDReport(windowsMap, navigate) {
    await handleAnalyticsAction(navigate, windowsMap)
  }
  const [mainLinks, setMainLinks] = useState([
    {
      tabid: 1,
      tempid: 1,
      icon: "home",
      action: "home",
      label: "Home",
    },
    {
      tabid: 7,
      tempid: 2,
      icon: "locations",
      action: "LocLanding",
      label: "Locations",
    },

    {
      tabid: 3,
      tempid: 3,
      icon: "users_icon",
      action: "userlanding",
      label: "Users",
    },
    {
      tabid: 2,
      tempid: 4,
      icon: "Phone_system",
      action: "phonenumbers",
      label: "Phone System",
    },
    ...(!isFiveNineAcc ? [
      {
        tabid: 6,
        tempid: 5,
        icon: "admin_tools",
        action: "accountinfolanding",
        label: "Admin Tools",
      },
    ] : []),
    ...(isBillingGroup ? [
      {
        tabid: 5,
        tempid: 6,
        icon: "billing",
        action: "usageSummary",
        label: "Billing",
      }] : []),
    {
      tabid: 4,
      tempid: 7,
      icon: "analytics",
      action: "analyticslanding",
      label: "Analytics",
    },
  ]);

  const [showBackButton, setShowBackButton] = useState(false);

  const startingPath = "/home";
  useEffect(() => {
    const currentPath = location.pathname;
    let pathHistory = JSON.parse(sessionStorage.getItem("path_history") || "[]");
    if (pathHistory.length === 0 || pathHistory[pathHistory.length - 1] !== currentPath) {
      pathHistory.push(currentPath);
      sessionStorage.setItem("path_history", JSON.stringify(pathHistory));
    }
    if (currentPath === startingPath && pathHistory.length === 1) {
      setShowBackButton(false);
    } else {
      setShowBackButton(true);
    }
  }, [location]);

  const handleBack = () => {
    let pathHistory = JSON.parse(sessionStorage.getItem("path_history") || "[]");
    if (pathHistory.length >= 1) {
      pathHistory.pop();
      sessionStorage.setItem("path_history", JSON.stringify(pathHistory));
      window.history.back();
    }
  };
  return (
    <>
      <header className="header-mobile">
        <nav className="navbar nav2 navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <button type="button" onClick={ToggleClass}
              className="navbar-toggler"
              data-mdb-toggle="collapse"
              data-mdb-target="#navbarCenteredExample"
              aria-controls="navbarCenteredExample"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fas fa-bars"></i>
            </button>
            <div className={isActive ? "collapse navbar-collapse justify-content-center" : "justify-content-center mob-bg"}
              id="navbarCenteredExample">
              {showBackButton && (
                <span className="backBtn">
                  <MDBBtn outline rounded className="mt-1 px-4" onClick={(e) => {
                    e.preventDefault();
                    handleBack();
                  }}>
                    <MDBIcon fas icon="angle-left me-2" /> Back
                  </MDBBtn>
                </span>
              )}
              <ul className="navbar-nav mb-2 mb-lg-0">
                {mainLinks.map((key) => (
                  <>
                    <li className="nav-item">
                      <div
                        className={
                          props.active == key.tabid * 1
                            ? "nav-link active"
                            : "nav-link"
                        }
                        aria-current="page"
                        onClick={(e) => goToSublink(e, key.action, key.tempid)}
                      >
                        <i className={key.icon}></i>
                        <span className="pt-1">
                          {key.label}
                        </span>
                      </div>
                    </li>
                  </>
                ))}
              </ul>
            </div>
          </div>
        </nav>
      </header >
      {showWarning && (
        <EditWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={handleOk}
        />
      )}
      {/* <ChatBotView /> */}


      <Tooltip anchorSelect=".askluna" place="top" className="exampleTooltip">
        Ask Luna
      </Tooltip>
    </>
  );
}
export default MainLinks;
